import React, { useEffect, useState } from "react";
import { getProduct } from "../../../../http/api/ProductAPI";
import CommonAutocomplete from "../../../../components/CommonAutocomplete";
import { fromKana } from "hepburn";
import { convertToHiragana } from "../../../../utils/convertToHalfWidthKana";
import { MODAL_STATE } from "../../../chain_store/ChainStoreUtils";

export const ProductAutocomplete = (props) => {
  const { product, setProduct, modalState } = props;
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const newProduct = products.find(
      (p) => p.productId === modalState.Value.productId
    );
    setProduct(newProduct);
  }, [modalState.Value.productId, products]);

  async function GetProduct() {
    try {
      let response = await getProduct({});
      let listProduct = response.listProductInfo;
      listProduct = listProduct
        .filter((x) => x.productKana != null && x.productName != null)
        .map((p) => ({
          ...p,
          productNameHira: convertToHiragana(p.productKana),
          productNameRomanji: fromKana(p.productKana),
        }))
        .sort((a, b) => a.productId - b.productId);
      setProducts(listProduct);
      console.log("商品リスト取得");
    } catch (e) {
      console.log("商品リストを取得する際にエラー発生した：", e);
    }
  }
  useEffect(() => {
    GetProduct();
  }, []);
  return (
    <div>
      <CommonAutocomplete
        label="品名"
        value={product || null}
        onSelect={(e, newValue) => {
          setProduct(newValue);
        }}
        data={products}
        filterOptions={(options, { inputValue }) => {
          inputValue = fromKana(inputValue.toUpperCase());
          return options.filter(
            (x) =>
              x.productId.toString().startsWith(inputValue) ||
              x.productName.includes(inputValue) ||
              x.productNameRomanji.includes(inputValue)
          );
        }}
        optionLabel={(option) =>
          (option.productId || "") +
          (option.productName ? " - " + (option.productName || "") : "")
        }
        width={"100%"}
        disabled={
          modalState.Value.mode === MODAL_STATE.UPDATE &&
          !modalState.Value.isAlien
        }
      />
    </div>
  );
};
